<template>
    <div class="mx-auto w-full max-w-[1168px] pb-40 px-8 pt-0">
        <template v-if="state==='loaded'">
            <ui-header :title="'Edit Draft Progress Report'" :subtitle="progress.id" class="sticky sticky-top top-0 pt-6 pb-4 bg-white z-30">
                <template #actions>
                    <ui-button-new primary @click.prevent="complete" :loading="busy" class="ml-3">Submit as a Completed</ui-button-new>
                    <ui-button-new icon="fas fa-trash" danger @click="openDeleteModal">Delete</ui-button-new>
                </template>
            </ui-header>
            <div class="grid gap-6 grid-cols-12 pb-6 pt-0">
                <ui-date-picker label="Progress Report Date" name="dateTime" v-model="progress.dateTime"
                                class="xl:col-span-6"
                                placeholder="What is date for this progress report?"
                                :error="dateTimeError"
                                :with-time="true"
                                @input="dateTimeError=''; save()"></ui-date-picker>
                <ui-input label="Weather" name="weather" v-model="progress.weather" placeholder="Dry, Rainy, etc"
                          class="xl:col-span-6" @input="save"></ui-input>
                <ui-input label="Work as Specification" name="workAsSpecification"
                          v-model="progress.workAsSpecification"
                          placeholder="Yes"
                          class="xl:col-span-6" @input="save"></ui-input>
                <ui-input label="Quality of Workmanship" name="qualityOfWorkmanship"
                          v-model="progress.qualityOfWorkmanship"
                          placeholder="Excellent"
                          class="xl:col-span-6" @input="save"></ui-input>
                <ui-textarea autoresize label="House Keeping" name="houseKeeping" v-model="progress.houseKeeping"
                             placeholder="House keeping for this progress report..."
                             class="xl:col-span-12" @input="save"></ui-textarea>
                <ui-textarea autoresize label="Site Safety" name="siteSafety" v-model="progress.siteSafety"
                             placeholder="Activities on site..."
                             class="xl:col-span-12" @input="save"></ui-textarea>
                <ui-textarea autoresize label="Comments" name="comments" v-model="progress.comments"
                             placeholder="Notes..."
                             class="xl:col-span-12" @input="save"></ui-textarea>
            </div>
            <div :key="contractRender">
                <div class="w-full mb-2 flex">
                    <div class="flex-grow">Progress Percentages</div>
                    <div class="flex-shrink mb-1">
                        <ui-button-new small
                                       class="items-baseline"
                                       icon="fas fa-upload"
                                       @click="showFS">Progress Report Files
                        </ui-button-new>
                    </div>
                </div>
                <div class="w-full border-gray-300 border rounded-lg p-2">
                    <progress-report-section v-for="section in progress.sections" :key="section.id"
                                             :progress="progress"
                                             :section="section"
                                             :fs-modal="fsModal"
                                             @changed="save"
                                             :readonly="false"
                    ></progress-report-section>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import UiContainer from "../ui/UiContainer.vue";
import UiDatePicker from "../ui/UiDatePicker.vue";
import UiButtonNew from "../ui/UiButtonNew.vue";
import UiDataGridItem from "../ui/UiDataGridItem.vue";
import UiHeader from "../ui/UiHeader.vue";
import UiInput from "../ui/UiInput.vue";
import UiToggle from "../ui/UiToggle.vue";
import {ProgressReport, ComponentBuildup, ContractedWorks} from "@models";
import ProgressReportSection from "./ProgressReportSection.vue";
import {resolveNumericText, uuid} from "../../utils";
import moment from "moment";
import {debounce} from "lodash";
import ProgressReportItem from "./ProgressReportItem.vue";
import * as math from "mathjs";

export default {
    components: {
        ProgressReportItem,
        ProgressReportSection,
        UiToggle, UiInput, UiHeader, UiDataGridItem, UiDatePicker, UiButtonNew, UiContainer
    },
    props: {
        item: Object,
        progressId: '',
        fsModal: Object,
        removeItem: Function,
    },
    data() {
        return {
            progress: {},
            contractRender: 0,
            busy: false,
            dateTimeError: '',
            moment,
            state: 'loading',
            debouncedUpdate: debounce(this.update, 300),
        }
    },
    computed: {},
    methods: {
        async save() {
            this.dateTimeError = '';
            if (!this.progress.dateTime) {
                this.dateTimeError = 'Please select a date/time for this Progress Report'
            } else {
                this.progress.formatted_date = moment(this.progress.dateTime).format('DD/MM/YYYY h:mm a');
                let complete = 0;
                this.progress.sections.forEach(section => {
                    section.tasks.forEach(task => {
                        task.items.forEach(item => {
                            complete += parseFloat(item.ratio) * (parseFloat(item.complete)/100)
                        })
                    })
                })

                this.progress.progressPercent = math.round(complete * 100, 2)
                this.progress.progressValue = math.round(resolveNumericText(this.progress.value) / 100 * this.progress.progressPercent, 2)
                Object.assign(this.item, this.progress);
                this.debouncedUpdate();
            }
        },
        async update() {
            this.busy = true;
            this.progress.dateTime = moment(this.progress.dateTime).format("YYYY-MM-DD HH:mm");
            await this.progress.update();
            this.busy = false;
        },
        showFS() {
            this.fsModal.openModal(this.progress.filesystemId, this.progress.filesystemPath);
        },
        async complete() {
            await this.progress.complete();
            Object.assign(this.item, this.progress);
            this.busy = false;
            this.$emit("statusChanged", this.item, this.progress);
        },
        checkDate(date) {
            let formDate = new Date(this.progress.date);
            return formDate < date;
        },
        minDate() {
            return null;
        },
        openDeleteModal () {
            const title = 'Are you sure you want to delete "Draft #' + this.progress.referenceNumber + '"?'
            const description = 'Deleting this draft progress report is irreversible. Are you sure you want to delete it?'
            eventBus.$emit('delete-modal-open', title, description, async () => {
                await this.progress.remove()
                this.removeItem(this.item)
            });
        },
    },
    async mounted() {
        this.progress = await ProgressReport.find(this.progressId);
        this.state = 'loaded'
        this.contractRender++;
    },
}
</script>
